import React, { useEffect, useState } from "react";
import { insertDataJson, updateItem, getData } from "../Tools/helpers";
import Alert from "@mui/material/Alert";
import { PageTitle } from "../components/PageHeader";

import TableHistoryCustom from "../components/TableHistoryCustom";
import DialogCustom from "../components/DialogCustom";

const Discharge = () => {
  const [isDialog, setIsDialog] = useState(false);
  const [itemCancel, setItemCancel] = useState(0);
  const [dataDischarges, setDataDischarges] = useState({
    method_payment: 0,
    amount: 0,
    description: "",
    segment: "",
    type: "",
    staff_id: 0,
  });
  const [data, setData] = useState([]);
  const [message, setMessage] = useState({
    status: false,
    message: "",
    label: "",
  });

  const getDischarges = async () => {
    const route = "Discharge";
    const send = await getData(route);
    if (send.code === 200) {
      setData(send.data);
    }
  };

  const setIds = async () => {
    const user = await JSON.parse(localStorage.getItem("USER_IUMV"));
    setDataDischarges({
      ...dataDischarges,
      university_id: user.university_id,
      staff_id: user.staff_id,
    });
  };

  const setState = (e) => {
    setDataDischarges({
      ...dataDischarges,
      [e.target.name]: e.target.value,
    });
  };

  const FieldsCustomTable = [
    { name: "id", label: "ID" },
    { name: "name", label: "Campus" },
    { name: "description", label: "Concepto" },
    { name: "type", label: "Tipo" },
    { name: "register_date", label: "Fecha" },
    { name: "amount", label: "Importe" },
    { name: "segment", label: "Segmento" },
    { name: "method_payment", label: "Forma de pago" },
    { name: "status_description", label: "Estatus" },
    { name: "approved_by", label: "Apropado por" },
    { name: "approved_date", label: "Fecha aprobación" },
    { name: "status", label: "" },
  ];

  const saveDischarge = async () => {
    setMessage({
      status: false,
      message: "",
      label: "",
    });

    if (
      dataDischarges.method_payment === 0 ||
      dataDischarges.amount === 0 ||
      dataDischarges.amount === "" ||
      dataDischarges.description === "" ||
      dataDischarges.segment === "" ||
      dataDischarges.type === ""
    ) {
      setMessage({
        status: true,
        message: "Todos los campos son requeridos",
        label: "error",
      });
      return;
    }

    setMessage({
      status: true,
      message: "Guardando...",
      label: "info",
    });

    const route = "Discharge";
    const send = await insertDataJson(route, dataDischarges);

    if (send.code === 201) {
      setMessage({
        status: true,
        message: "Se ha guardado correctamente",
        label: "success",
      });
      getDischarges();
      return;
    }
    setMessage({
      status: true,
      message: "Ha ocurrido algo, intente de nuevo",
      label: "error",
    });
  };

  const activeDialog = (row) => {
    setItemCancel(row);
    setIsDialog(true);
  };

  const cancelDischarge = async (option) => {
    setMessage({
      status: false,
      message: "",
      label: "",
    });

    setIsDialog(false);
    if (!option) {
      return;
    }
    setMessage({
      status: true,
      message: "Cancelando...",
      label: "info",
    });

    const dataStatus = {
      status: 1,
      status_description: 'Cancelado'
    };

    const route = "Discharge";
    const send = await updateItem(`${route}/${itemCancel.id}`, dataStatus);
    if (send.code === 200) {
      setMessage({
        status: true,
        message: "Se ha cancelado correctamente",
        label: "success",
      });
      getDischarges();
      return;
    }
    setMessage({
      status: true,
      message: "Ha ocurrido algo, intente de nuevo",
      label: "error",
    });
  };

  useEffect(() => {
    setIds();
    getDischarges();
  }, []);

  const inputStyle = {
    width: '100%',
    padding: '8px 12px',
    border: '1px solid #d1d5db',
    borderRadius: '6px',
    fontSize: '0.85rem',
    color: '#111827',
    outline: 'none',
    backgroundColor: '#fff',
    transition: 'border-color 0.15s',
  };

  const selectStyle = {
    ...inputStyle,
    cursor: 'pointer',
  };

  const focusIn = (e) => { e.target.style.borderColor = '#dc2626'; e.target.style.boxShadow = '0 0 0 2px rgba(220,38,38,0.1)'; };
  const focusOut = (e) => { e.target.style.borderColor = '#d1d5db'; e.target.style.boxShadow = 'none'; };

  const labelStyle = {
    display: 'block',
    fontSize: '0.75rem',
    fontWeight: 600,
    color: '#374151',
    marginBottom: '5px',
    textTransform: 'uppercase',
    letterSpacing: '0.04em',
  };

  return (
    <div>
      <DialogCustom
        open={isDialog}
        message={{ title: "Cancelar", message: "¿Desea cancelar el registro de ingreso?" }}
        action={cancelDischarge}
      />

      <PageTitle>Egreso</PageTitle>

      {/* Form card */}
      <div style={{
        backgroundColor: '#f8fafc',
        border: '1px solid #e2e8f0',
        borderRadius: '8px',
        padding: '20px 24px',
        marginTop: '16px',
        marginBottom: '24px',
        maxWidth: '600px',
      }}>
        {/* Card header */}
        <div style={{ borderLeft: '4px solid #dc2626', paddingLeft: '10px', marginBottom: '18px' }}>
          <span style={{ fontSize: '0.78rem', fontWeight: 700, color: '#111827', textTransform: 'uppercase', letterSpacing: '0.05em' }}>
            Nuevo Registro
          </span>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2" style={{ gap: '14px' }}>
          {/* Importe */}
          <div>
            <label style={labelStyle}>Importe</label>
            <input
              style={inputStyle}
              type="number"
              name="amount"
              value={dataDischarges.amount}
              onChange={setState}
              onFocus={focusIn}
              onBlur={focusOut}
              placeholder="0.00"
            />
          </div>

          {/* Tipo */}
          <div>
            <label style={labelStyle}>Tipo</label>
            <input
              style={inputStyle}
              type="text"
              name="type"
              value={dataDischarges.type}
              onChange={setState}
              onFocus={focusIn}
              onBlur={focusOut}
            />
          </div>

          {/* Concepto */}
          <div>
            <label style={labelStyle}>Concepto</label>
            <input
              style={inputStyle}
              type="text"
              name="description"
              value={dataDischarges.description}
              onChange={setState}
              onFocus={focusIn}
              onBlur={focusOut}
            />
          </div>

          {/* Forma de pago */}
          <div>
            <label style={labelStyle}>Forma de pago</label>
            <select
              style={selectStyle}
              name="method_payment"
              value={dataDischarges.method_payment}
              onChange={setState}
              onFocus={focusIn}
              onBlur={focusOut}
            >
              <option value="0">Seleccione una opción</option>
              <option value="Efectivo">Efectivo</option>
              <option value="Tarjeta">Tarjeta</option>
              <option value="Deposito">Deposito</option>
              <option value="Transferencia">Transferencia</option>
            </select>
          </div>

          {/* Segmento */}
          <div>
            <label style={labelStyle}>Segmento</label>
            <input
              style={inputStyle}
              type="text"
              name="segment"
              value={dataDischarges.segment}
              onChange={setState}
              onFocus={focusIn}
              onBlur={focusOut}
            />
          </div>
        </div>

        {/* Alert */}
        {message.status && (
          <Alert className="mt-3" severity={message.label}>
            {message.message}
          </Alert>
        )}

        {/* Submit */}
        <div style={{ marginTop: '18px', display: 'flex', justifyContent: 'flex-end' }}>
          <button
            onClick={() => saveDischarge()}
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '7px',
              backgroundColor: '#111827',
              color: '#fff',
              border: 'none',
              borderRadius: '6px',
              padding: '9px 22px',
              fontSize: '0.78rem',
              fontWeight: 700,
              textTransform: 'uppercase',
              letterSpacing: '0.05em',
              cursor: 'pointer',
            }}
            onMouseEnter={e => { e.currentTarget.style.backgroundColor = '#dc2626'; }}
            onMouseLeave={e => { e.currentTarget.style.backgroundColor = '#111827'; }}
          >
            <i className="fa-solid fa-plus" style={{ fontSize: '11px' }}></i>
            Agregar
          </button>
        </div>
      </div>

      <TableHistoryCustom
        fields={FieldsCustomTable}
        data={data}
        actionType={["cancel"]}
        action={activeDialog}
      />
    </div>
  );
};

export default Discharge;
